import React, { Component } from 'react';
import { Container, Button, Form, FormGroup, Label, Input, FormFeedback, Row, Col, CardHeader, Card, ListGroup, ListGroupItem, CardBody, Modal, ModalHeader, ModalBody, CardLink, Media } from 'reactstrap'
import Header from '../../Componentes/header'
import Nav from '../../Componentes/nav'
import Footer from '../../Componentes/footer'
import '../../CSS/bootstrap.min.css'
import '../../CSS/style.css'
import Fetch from '../../Auxiliares/fetch'
import { toast } from 'react-toastify';
import validaciones from '../../Auxiliares/validaciones'
import ReactFileReader from 'react-file-reader'
import SideBar from '../../Img/SideBar.png'
import Return from '../../Img/Regresar.png'

export default class Digitalizar extends Component {
    constructor(state) {
        super(state);
        this.state = {
            //vista
            contenido: '',

            //Fetch
            convocatorias: [],
            periodos: [],

            //send
            convocatoria: "",
            tipoReporte: "Sin Seleccionar",
            etapaConvocatoria: "",
            clickable: false,

            descargar: "",

            reportes: ["Sin Seleccionar", "Estado de todos los documentos"], //, "Estado de todos los documentos aceptados", "Estado de todos los documentos en revision", "Estado de todos los documentos en vacio"

        }
        this.buscar = this.buscar.bind(this)
    }

    componentDidMount() {
        this.actualizarLista();
    }

    convocatoriaChange(ev){
        this.setState({clickable: true})
        if(ev!=this.state.convocatoria){
        this.setState({etapaConvocatoria: 0})
        Fetch('/getPeriodosConvocatoria', {
            method: 'POST',
            headers: { 'Content-Type': 'application/JSON' },
            body: JSON.stringify({ convocatoria: ev})
            //body: data
        })
            .then(response => {
                this.setState({ periodos: response.data })
                this.setState({clickable: false})
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        this.setState({clickable: false})
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ periodos: [] })
                        this.setState({clickable: false})
                        break;

                    default:
                        this.setState({clickable: false})
                        break;
                }
            })
        }
    }

    setValue(field, ev) {
        if(field == "convocatoria") this.convocatoriaChange(ev.target.value)
        this.setState({ [field]: ev.target.value }, () => {
            let value;
            switch ([field].toString()) {
                default:
                    break;
            }
        })
    }

    buscar() {
        var index = this.state.reportes.indexOf(this.state.tipoReporte)
        var etapa = this.state.etapaConvocatoria;

        if (index != 0) {
            switch (index) {
                case 1:
                    Fetch('/reporteTodosACsv', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ convocatoria: this.state.convocatoria, etapa })
                    })
                    .then(response => {
                        this.setState({ descargar: <a href={response.csv} download>Descargar archivo CSV</a> })
                    })
                    .catch(err => {
                        switch (err.status) {
        
                            case 600:
                                console.log('Error inesperado')
                                break;
        
                            default:
                                break;
                        }
                    })
                break;

                case 2:
                    Fetch('/reporteAceptadoACsv', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ convocatoria: this.state.convocatoria })
                    })
                    .then(response => {
                        this.setState({ descargar: <a href={response.csv} download>Descargar archivo CSV</a> })
                    })
                    .catch(err => {
                        switch (err.status) {
        
                            case 600:
                                console.log('Error inesperado')
                                break;
        
                            default:
                                break;
                        }
                    })
                break;

                case 3:
                    Fetch('/reporteRevisionACsv', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ convocatoria: this.state.convocatoria })
                    })
                    .then(response => {
                        this.setState({ descargar: <a href={response.csv} download>Descargar archivo CSV</a> })
                    })
                    .catch(err => {
                        switch (err.status) {
        
                            case 600:
                                console.log('Error inesperado')
                                break;
        
                            default:
                                break;
                        }
                    })
                break;
                
                case 4:
                    Fetch('/reporteVacioACsv', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ convocatoria: this.state.convocatoria })
                    })
                        .then(response => {
                            this.setState({ descargar: <a href={response.csv} download>Descargar archivo CSV</a> })
                        })
                        .catch(err => {
                            switch (err.status) {
            
                                case 600:
                                    console.log('Error inesperado')
                                    break;
            
                                default:
                                    break;
                            }
                    })
                break;

                default:
                    console.log("Error de indice")
                    break;

            }
        }
    }

    actualizarLista() {
        Fetch('/getInscripciones', {
            method: 'POST',
            headers: { 'Content-Type': 'multipart/form-data' }
        })
            .then(response => {
                this.setState({ convocatorias: response.data })
            })
            .catch(err => {
                switch (err.status) {

                    case 600:
                        console.log('Error inesperado')
                        break;

                    case 605:
                        console.log('Listado de elementos vacia')
                        this.setState({ convocatorias: [] })
                        break;

                    default:
                        break;
                }
            })
    }

    render() {
        return (
            <html>
                <Header />
                <Row>
                    <Col className="bg-light" lg="3">
                        <Nav usuario={sessionStorage.getItem('usuario')} tipo={sessionStorage.getItem('rol')} />
                    </Col>

                    <Col className="bg-light" lg="9">
                        <div class="container-fluid">
                            <h1 class="mt-2 mb-2 text-center">Generador de reportes</h1>
                        </div>
                        <Container>
                            <Card className="p-4">
                                <Row className="mb-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="4" className="text-center text-md-right mb-2">
                                        Convocatoria
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input type="select" name="convocatoria" className="col-12" onChange={this.setValue.bind(this, "convocatoria")} onKeyPress={this.handleKeyPress} value={this.state.convocatoria || 0}>
                                            <option value={0}> Sin Seleccionar </option>
                                            {this.state.convocatorias.map(elem =>
                                                <option hidden={!elem.convocatoria} value={elem.id}> {elem.convocatoria} </option>)}
                                        </Input>
                                    </Col>
                                </Row>
                                <Row className="mt-3 mb-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="4" className="text-center text-md-right mb-2">
                                        Etapa/Periodo de Convocatoria
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input disabled={this.state.clickable} type="select" name="etapaConvocatoria" className="col-12" onChange={this.setValue.bind(this, "etapaConvocatoria")} onKeyPress={this.handleKeyPress} value={this.state.etapaConvocatoria || 0}>
                                            <option value={0}> Sin Seleccionar </option>
                                            {this.state.periodos.map((elem) => (
                                                <option hidden={!elem.etapa} value={elem.etapa}>{elem.etapa}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                </Row>
                                <Row className="mt-3 mb-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="4" className="text-center text-md-right mb-2">
                                        Tipo de Reporte
                                    </Col>
                                    <Col xs="12" md="8">
                                        <Input type="select" name="tipoReporte" className="col-12" onChange={this.setValue.bind(this, "tipoReporte")} onKeyPress={this.handleKeyPress} value={this.state.tipoReporte || 0}>
                                            {this.state.reportes.map((index) => (
                                                <option>{index}</option>
                                            ))}
                                        </Input>
                                    </Col>
                                </Row>
                                <Row className="mt-3 mb-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="6">
                                        <Button className="list-group-item"
                                            style={{
                                                background: `url(${SideBar})`, backgroundSize: 'cover', backgroundPosition: 'center',
                                                fontSize: '20px'
                                            }}
                                            onClick={this.buscar} block disabled={!(this.state.convocatoria != 0 && this.state.tipoReporte != "Sin Seleccionar" && this.state.etapaConvocatoria != 0)} >Generar Reporte</Button>
                                        <Label className="text-center mt-3"> Por favor, seleccione el periodo de la convocatoria y el tipo de reporte a generar</Label>
                                    </Col>
                                </Row>
                                
                                
                                {this.state.descargar != "" ? <Row className="mt-3 mb-2" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <Col xs="12" md="6">
                                        {this.state.descargar}
                                    </Col>
                                </Row> : "" }
                            </Card>
                        </Container>
                    </Col>
                </Row>
                <Footer />
            </html>
        )
    }
}
